export default {
  toggleChart: false,
  advancedFilter: [false, false, false, false],
  scrapingState: {
    PENDING: 0,
    IN_PROGRESS: 1,
    COMPLETED: 2,
    COMPLETED_IN_PROGRESS: 3,
    FORCE_UPDATE: 4
  },
  scrapingStatesText: {
    0: 'PENDING', // Queued for scraping...
    1: 'IN PROGRESS', // Scraping in progress... (show percent)
    2: 'COMPLETED', // Scraping completed.
    3: 'IN PROGRESS', // Scraping in progress... (show percent)
    4: 'FORCE UPDATE' // Processing...
  },
  scrapingStatesColors: {
    0: 'info', // Queued for scraping...
    1: 'blue', // Scraping in progress... (show percent)
    2: 'success', // Scraping completed.
    3: 'blue', // Scraping in progress... (show percent)
    4: 'warning' // Processing...
  },
  selectedHeaders: [
    {
      rows: true,
      name: true,
      url: true,
      tags: true,
      importance: true,
      current_rank: true,
      change: true,
      volume: true,
      links_count: true,
      estimated: true,
      // potential: true,
      // delta: true,
      added_potential: true,
      term: true,
      completed_at: true,
      actions: true
    },
    {
      rows: true,
      name: true,
      tags: true,
      importance: true,
      volume: true,
      links_count: true,
      actions: true
    },
    {
      rows: true,
      name: true,
      url: true,
      tags: true,
      importance: true,
      current_rank: true,
      change: true,
      volume: true,
      links_count: true,
      estimated: true,
      // potential: true,
      // delta: true,
      added_potential: true,
      term: true,
      completed_at: true,
      actions: true
    },
    {
      rows: true,
      url: true,
      // pages_to_links: true,
      increased: true,
      // increased_percent: true,
      decreased: true,
      // decreased_percent: true,
      not_changed: true,
      // not_changed_percent: true,
      unknown: true,
      // unknown_percent: true,
      importance: true,
      pr: true,
      keywords: true,
      keywords_percent: true,
      links_count: true,
      inner_links_count: true,
      total_potential: true,
      total_estimated: true
    }
  ],
  selectedHeadersNames: {
    rows: 'Rows',
    name: 'Keyword',
    url: 'Url',
    tags: 'Tags',
    importance: 'Keyword Importance',
    pr: 'PR',
    current_rank: 'Last rank',
    change: 'Change',
    volume: 'Monthly Search Volume',
    links_count: 'Anchor Links',
    inner_links_count: 'Inner Links',
    pages_to_links: 'Pages to links',
    estimated: 'Monthly Estimated',
    // potential: 'Potential',
    total_potential: 'Potential',
    delta: 'Monthly Potential',
    added_potential: 'Added Monthly Potential',
    term: 'Time Frame',
    completed_at: 'Last updated',
    actions: 'Actions',
    increased: 'Increased',
    increased_percent: 'Increased %',
    decreased: 'Decreased',
    decreased_percent: 'Decreased %',
    not_changed: 'Not changed',
    not_changed_percent: 'Not changed %',
    unknown: 'Unknown',
    unknown_percent: 'Unknown %',
    keywords_percent: 'Total keywords %',
    keywords: 'Total keywords',
    total_estimated: 'Estimated'
  },
  suggestedDomainsSearchStates: {
    pending: 0,
    alreadyHasAlternativeDomain: 1,
    notFound: 2,
    found: 3,
    applied: 4,
    skipped: 5
  },
  categories: [
    'Amazon',
    'Android',
    'Apple',
    'AppStore',
    'Google',
    'Google Play',
    'Instagram',
    'iphone',
    'Linkedin',
    'personal assistant app',
    'Youtube',
    'אוכל ושתיה',
    'אומנות',
    'אונליין ודיגיטל',
    'אחסון אתרים ודומיינים',
    'אחר (Other)',
    'חתונה ואירועים',
    'אלקטרוניקה',
    'אמנות ועיצוב',
    'אפליקציות',
    'בידור',
    'בית חכם',
    'בניית אתרים',
    'בעלי מקצוע/ נותני שירות',
    'בריאות וכושר',
    'גוגל אנליטיקס וסטטיסטיקה',
    'גרפיקה ועיצוב (UX/UI)',
    'דיאטה ותזונה',
    'דייטים וזוגיות',
    'הדמיה',
    'הורוסקופ וניו אייג`',
    'הורים',
    'הימורים',
    'הלבשה ונעליים',
    'הסביבה הקרובה (לוקאל)',
    'וורדפרס (Wordpress)',
    'חדשות',
    'חיות',
    'חיילים וצבא',
    'חינוך',
    'טיפוח ויופי',
    'טכנולוגיה וגאדטים',
    'טלפונים ניידים ואביזרים',
    'יד שנייה',
    'ילדים',
    'כלים',
    'כלים לשיווק באינטרנט',
    'כתיבה שיווקית ותוכן',
    'לבית או לגינה',
    'לוח',
    'לייף סטייל',
    'לימודים',
    'למטבח',
    'מוזיקה ואודיו',
    'מזג אוויר',
    'מחשבים וטאבלטים',
    'מסחר אלקטרוני (ecommerce)',
    'מפות וניווט',
    'משחק תפקידים',
    'משחקים',
    'משפחה',
    'נגנים וכלי עריכה לווידאו',
    'נדל"ן',
    'נטפליקס וסטרימינג',
    "ניהול מוניטין ויח'צ",
    'נסיעות ותיירות',
    'סטודנטים',
    'ספורט',
    'ספרים',
    'סרטוני וידאו',
    'סרטים וקולנוע',
    'עיצוב פנים',
    'עיתונים ומגזינים',
    'עסקים',
    'פיננסיים',
    'פנאי',
    'פרודוקטיביות',
    'פרסום ממומן (PPC)',
    'צילום',
    'צעצועים ומשחקים',
    'קומיקס',
    'קוסמטיקה',
    'קטלוגים',
    'קידום אתרים (SEO)',
    'קלפים ואוספים',
    'קניות ומוצרים',
    'רכב ונהיגה',
    'רפואה/ רפואה אלטרנטיבית',
    'רשתות חברתיות',
    'שיווק באינטרנט',
    'שיווק באמצעות וידאו',
    'שיווק במדיה חברתית',
    'שיפור הבית',
    'שיפור עצמי',
    'תוכנה ופיתוח',
    'תוכנות ושירותי אונליין (SaaS)',
    'תוכניות שותפים ואפיליאייטס',
    'תחביבים',
    'תינוקות',
    'תקשורת',
    'דרושים וחיפוש עבודה'
  ]
}



// WEBPACK FOOTER //
// ./src/store/project/state.js